"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.tab.instructions': 'Istruzioni',
    'trainer.tab.upload': 'Carica Dati',
    'trainer.tab.config': 'Configura Addestramento',
    'trainer.tab.training': 'Progresso Addestramento',
    'trainer.tab.results': 'Risultati',
};
